import { Component, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { MarketDepthModel } from './MarketDepth.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { GotxMarketDepthComponent } from '../../../gotx/components/gotx-market-depth/gotx-market-depth.component';
import { GotxKeyValueListComponent } from '../../../gotx/components/gotx-key-value-list/gotx-key-value-list.component';
import { StockComponent } from '../../components/Stock/Stock.component';
import { MarketWatchService } from 'src/app/market-watch.service';

const customCss: string = '';

@Component({
  selector: 'app-MarketDepth',
  templateUrl: './MarketDepth.component.html'
})
export class MarketDepthComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('btSubmit', { static: false }) btSubmit: ButtonComponent;
  @ViewChild('MarketDepthChart', { static: false }) MarketDepthChart: ElementRef;
  @ViewChild('grpGotxMarketDepth', { static: false }) grpGotxMarketDepth: ElementRef;
  @ViewChild('GotxMarketDepth', { static: false }) GotxMarketDepth: GotxMarketDepthComponent;
  @ViewChild('MarketDetails', { static: false }) MarketDetails: GotxKeyValueListComponent;
  @ViewChild('grpGotxKeyValueList', { static: false }) grpGotxKeyValueList: ElementRef;
  @ViewChild('KeyvalueList', { static: false }) KeyvalueList: GotxKeyValueListComponent;
  @ViewChild('KeyValueList1', { static: false }) KeyValueList1: GotxKeyValueListComponent;
  @ViewChild('KeyValueList2', { static: false }) KeyValueList2: GotxKeyValueListComponent;
  @ViewChild('FieldId_15', { static: false }) FieldId_15: ElementRef;
  @Input('params') params: any = null;
  skeletonContentLoaded = false;
  symbol: string = '';
  symbolName = "NA";
  keyValueList: any[] = [];
  keyValueList1: any[] = [];
  keyValueList2: any[] = [];
  DetailList: any[] = [];
  exchSymbol: string = '';
  exchange: string = '';
  product: string = '';
  selectedStock: any;
  subbedStock = null;
  productSelected = this.services.dataStore.getproductMasterData();

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmProduct.revalidate(),
      this.tabComponent_revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock, private marketService: MarketWatchService) {
    super(services);
    this.value = new MarketDepthModel();
    this.componentCode = 'MarketDepth';
    this.initHTabGroup('tabComponent', ['DepthTab', 'DetailsTab',], 'DepthTab', 1);
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmProduct.setReadOnly(readOnly);
  }
  async onFormLoad() {
    console.log("this.params market depth",this.params);
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.openHTab('tabComponent', 'DepthTab');
    // this.cstmProduct.setReadOnly(true);
    this.cmbStock.gotxInput.focus();
    this.setDependencies();
    this.reloadStock();

    if (this.params) {
      this.exchange = this.params.exchange;
      this.product = this.params.product;
      this.symbol = this.params.symbol;
      this.exchSymbol = this.params.exchSymbol;

      this.cstmProduct.cmbProduct.setValue(this.params.product);
      this.cmbStock.gotxInput.val(this.params.symbol);

      this.getQuoteAndSubscribe();
    }

    this.keyValueList = [];
    this.keyValueList.push({ key: "MarketDepthGrid.Open", value: 'open', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList.push({ key: "MarketDepthGrid.Close", value: 'close', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList.push({ key: "MarketDepthGrid.High", value: 'highPrice', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList.push({ key: "MarketDepthGrid.Low", value: 'lowPrice', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList.push({ key: "MarketDepthGrid.CircuitBreakerHigh", value: 'circuitHigh', textAlign: "right", decimalFormatter: "1.2-2" });
    // this.keyValueList.push({ key: "MarketDepthGrid.TotalSellQty", value: selectedStock.totalsellqty, textAlign: "right", format: '' });

    this.keyValueList1 = [];
    this.keyValueList1.push({ key: "MarketDepthGrid.LastPrice", value: 'lastPrice', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList1.push({ key: "MarketDepthGrid.LastTradedQty", value: 'tradeQty', textAlign: "right", format: '' });
    this.keyValueList1.push({ key: "MarketDepthGrid.LastTradedTime", value: 'lastTradeTime', textAlign: "right" });
    this.keyValueList1.push({ key: "MarketDepthGrid.Volume", value: 'volume', textAlign: "right", format: '' });
    this.keyValueList1.push({ key: "MarketDepthGrid.CircuitBreakerLow", value: 'circuitLow', textAlign: "right", decimalFormatter: "1.2-2" });

    this.keyValueList2 = [];
    this.keyValueList2.push({ key: "MarketDepthGrid.Turnover", value: 'turnover', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList2.push({ key: "MarketDepthGrid.PrevClose", value: 'prevClose', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList2.push({ key: "MarketDepthGrid.TotalBidQty", value: 'totalBuyQty', textAlign: "right", format: '' });
    this.keyValueList2.push({ key: "MarketDepthGrid.TotalAskQty", value: 'totalSellQty', textAlign: "right", format: '' });
    this.keyValueList2.push({ key: "MarketDepthGrid.BuyVWAP", value: 'buyVWAP', textAlign: "right", decimalFormatter: "1.2-2" });
    this.keyValueList2.push({ key: "MarketDepthGrid.SellVWAp", value: 'sellVWAP', textAlign: "right", decimalFormatter: "1.2-2" });
    this.cstmProduct.setProductDropDown();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'MarketDepth';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmProduct_desc'] = this.cstmProduct.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmProduct = this.cstmProduct.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmProduct.setValue(inputValue['cstmProduct'], inputDesc['cstmProduct_desc']);
    this.value = new MarketDepthModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
    this.productSelected = value;
  }

  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'MarketDepth'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'MarketDepth_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
    this.DetailList = [];
    this.DetailList.push({ key: "InstrumentDetails.SecurityName", value: "", textAlign: "right" });
    this.DetailList.push({ key: "InstrumentDetails.ISINCode", value: "", textAlign: "right" });
    this.DetailList.push({ key: "InstrumentDetails.Facevalue", value: "", textAlign: "right" });
    this.DetailList.push({ key: "InstrumentDetails.IssuedQuantity", value: "", textAlign: "right", format: '' });
    this.DetailList.push({ key: "InstrumentDetails.IssuedPrice", value: "", textAlign: "right", decimalFormatter: "1.2-2" });
    this.DetailList.push({ key: "InstrumentDetails.TickSize", value: "", textAlign: "right" });
    this.DetailList.push({ key: "InstrumentDetails.LotSize", value: "", textAlign: "right" });
    this.DetailList.push({ key: "InstrumentDetails.InstrumentStatus", value: "", textAlign: "right" });
    this.setProductField(this.productSelected);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('MarketDepth_customCss');
    styleElement.parentNode.removeChild(styleElement);
    if (this.subbedStock != null)
      this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmProduct.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmProduct.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new MarketDepthModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbStock_stockSelected() {
    // console.log("Stock in Market Depth: ", this.cmbStock.gotxInput.val());
    if (this.cmbStock.gotxInput.val() != null && this.cmbStock.gotxInput.val().value != null) {
      if (this.cmbStock.gotxInput.val().value != this.cmbStock.gotxInput.val().label) {
        this.exchSymbol = this.cmbStock.gotxInput.val().value;
      }
    }
  }
  async cstmProduct_productSelected() {
    this.reloadStock();
  }
  reloadStock() {
    if (this.cstmProduct != undefined) {
      this.cmbStock.gotxInput.val("");
      let exch = this.services.dataStore.getData("exchangeID");
      let pdct = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof pdct == 'object' ){
        pdct = pdct.text
    }
      let board = "AL";
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct, board);
    }
  }
  getSymbol() {
    if (this.cmbStock.gotxInput.val().label) {
      return this.cmbStock.gotxInput.val().label;
    } else {
      return this.cmbStock.gotxInput.val();
    }
  }
  async btSubmit_click() {
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv').innerHTML = "";
    if (errorCount == 0) {
      this.exchange = this.services.dataStore.getData("exchangeID");
      this.product = this.cstmProduct.cmbProduct.getFieldValue();
      this.symbol = this.getSymbol();
      // this.exchSymbol = this.cmbStock.gotxInput.val().value;

      this.getQuoteAndSubscribe();
    }
  }
  async getQuoteAndSubscribe() {
    let stockKey = this.exchange + "#" + this.product + "#" + this.exchSymbol;
    this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
    this.marketService.getStockQuote(this.exchange, this.product, this.symbol);

    if (this.selectedStock && this.exchSymbol.length <= 0) {
      this.exchSymbol = this.selectedStock.exchSymbol;
    }

    let alreadySub = this.services.dataStore.subbedStocks.filter(el => el.Exch == this.exchange && el.Symbol == this.exchSymbol
      && el.Product == this.product);

    //console.log("alreadySub", alreadySub);

    if (this.subbedStock != null) {
      this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
    }

    if ((alreadySub == null || alreadySub.length <= 0) && this.exchSymbol != null) {
      this.subbedStock = { "Symbol": this.exchSymbol, "Exch": this.exchange, "Product": this.product };
      this.marketService.marketWatchStockSubs([this.subbedStock], 'DEPTH.IWS.DATA.REQ');//DEPTH.DATA.REQ // MW.IWS.STOCKS.SUBS
    } else {
      this.subbedStock = null;
    }

    let inputMap = new Map();
    inputMap.set('Body.exchange', this.exchange);
    inputMap.set('Body.symbol', this.symbol);
    inputMap.set('Body.product', this.product);
    inputMap.set('Body.reportType', "information");
    this.services.http.fetchApi('/stock/instrumentdetails', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          let resObj = res['response'];
          //added by pooja starts
          
           // let expiry: string = resObj.expiryDate;
            let expiry: string = resObj.expirydate.toString();
            resObj.expirydate = expiry.slice(6, 8).concat("/").concat(expiry.slice(4, 6)).concat("/").concat(expiry.slice(0, 4));
          
          //added by shanmugapriya new fields to show in the contract details
         if (resObj.InstrumentStatus === 'TR' || resObj.status === 'TR') {
            resObj.InstrumentStatus = 'Tradable';
         } else if (resObj.InstrumentStatus === 'TS' || resObj.status === 'TS') {
            resObj.InstrumentStatus = 'Trading Suspended';
         }
         console.log("resObj.InstrumentStatus..",resObj.InstrumentStatus);
          //added by pooja ends
          this.DetailList = [];
          if(this.product == "EQUITY"){ //condition added by pooja
            this.DetailList.push({ key: "InstrumentDetails.SecurityName", value: resObj.secName, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.ISINCode", value: resObj.isinKey, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.Facevalue", value: resObj.faceValue, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.IssuedQuantity", value: resObj.issuedQty, textAlign: "right", format: '' });
            this.DetailList.push({ key: "InstrumentDetails.IssuedPrice", value: resObj.issuedPrice, textAlign: "right", decimalFormatter: "1.2-2" });
            this.DetailList.push({ key: "InstrumentDetails.TickSize", value: resObj.tickSize, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.LotSize", value: resObj.lotsize, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.InstrumentStatus", value: resObj.InstrumentStatus, textAlign: "right" });
  
          } else{
            this.DetailList.push({ key: "InstrumentDetails.UnderlyingSymbol", value: resObj.uniqueSymbol, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.OptionType", value: resObj.optiontype, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.StrikePrice", value: resObj.strikeprice, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.ExpiryDate", value: resObj.expirydate, textAlign: "right" ,format:'yyyy/MM/DD'});
            this.DetailList.push({ key: "InstrumentDetails.LotSize", value: resObj.dlotsize, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.TickSize", value: resObj.tickSize, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.QtyUnit", value: resObj.qtyunit, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.PriceUnit", value: resObj.priceunit, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.DeliveryUnit", value: resObj.deliveryunit, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.QTYMultiplier", value: resObj.multiplier, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.PriceMultiplier", value: resObj.pricemultiplier, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.InitialMarginPct", value: resObj.carryfwdmargin, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.ELMMarginPct", value: resObj.grossexposuremagin, textAlign: "right" });
            //added by shanmugapriya new fields to show in the contract details
            this.DetailList.push({ key: "InstrumentDetails.SpecialBuyMarginPct", value: resObj.speciallbuymargin, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.SpecialSellMarginPct", value: resObj.speciallsellmargin, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.AdditonalBuyMarginPct", value: resObj.addbuymargin, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.AdditonalSellMarginPct", value: resObj.addsellmargin, textAlign: "right" });
            this.DetailList.push({ key: "InstrumentDetails.NearmonthSpreadPct", value: resObj.NmSpreadPct, textAlign: "right" }); 
            this.DetailList.push({ key: "InstrumentDetails.FarmonthSpreadPct", value: resObj.FmSpreadPct, textAlign: "right" }); 
            this.DetailList.push({ key: "InstrumentDetails.InstruStatus", value: resObj.InstrumentStatus, textAlign: "right" });              
          }
          
        } else {
          //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	  //commented by Shanmuga Priya - VAPT
          const rawMsg = res['errMsg'];
          const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
          (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          if (err['ErrorElementPath'] == 'product') {
            this.cstmProduct.cmbProduct.setError(err['ErrorDescription']);
          }
        }
        document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');

      }
    );
  }
  async DepthTab_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.hTabGroups['tabComponent'].tabs['DepthTab'].errorCount = totalErrors;
    return totalErrors;
  }
  async DetailsTab_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.hTabGroups['tabComponent'].tabs['DetailsTab'].errorCount = totalErrors;
    return totalErrors;
  }
  async tabComponent_revalidate(): Promise<number> {
    var totalErrors = 0;
    await Promise.all([
      this.DepthTab_revalidate(),
      this.DetailsTab_revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    return totalErrors;
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }
  fieldDependencies = {
  }
  /* Write Custom Scripts Here */
}